import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map, includes } from 'lodash';
import { Form, Col } from 'react-bootstrap';

import { GEOREF_TYPES, LAYER_SUBTYPES, LAYER_TYPES } from '../../../api/Layers/Layers';
import * as layerOps from '../../../api/Layers/layer-operations';

const LayerH3IndexField = ({
  georefType,
  layer,
  layerSubType,
  layerType,
  thematicKeyList,
  loadSpatialGeoJSON
}) => {
  const thematicListToUse = isEmpty(thematicKeyList)
    ? map(layerOps.getGeoJSONProps(layer), 'name')
    : thematicKeyList;

  const [h3Index, changeH3Index] = useState(layerOps.getH3Index(layer));
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return; // Skipping first render
    }
    changeH3Index('');
  }, [georefType, layerSubType, layerType, thematicListToUse]);

  if (
    !includes(
      [LAYER_SUBTYPES.CSV, LAYER_SUBTYPES.EXCEL, LAYER_SUBTYPES.GOOGLE_SHEETS],
      layerSubType
    ) ||
    georefType !== GEOREF_TYPES.H3 ||
    LAYER_TYPES.SPATIAL !== layerType ||
    isEmpty(thematicListToUse)
  )
    return '';
  return (
    <Form.Row className="mt-3">
      <Col xs={12}>
        <Form.Group>
          <Form.Label>H3 Index</Form.Label>
          <Form.Control
            as="select"
            name="h3Index"
            value={h3Index}
            onChange={event => {
              changeH3Index(event.target.value.trim());
              loadSpatialGeoJSON(event);
            }}
          >
            <option value="">-</option>
            {map(thematicListToUse, key => {
              return (
                <option value={key} key={key}>
                  {key}
                </option>
              );
            })}
          </Form.Control>
        </Form.Group>
      </Col>
    </Form.Row>
  );
};

LayerH3IndexField.propTypes = {
  georefType: PropTypes.string.isRequired,
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired,
  thematicKeyList: PropTypes.array.isRequired,
  layerType: PropTypes.string.isRequired,
  loadSpatialGeoJSON: PropTypes.func.isRequired
};

export default LayerH3IndexField;
